(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drywater-frontpage-top-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', e => {

    function initTypedText(nextWordPlease) {
      const endOfWordDelay = 1000;
      document.querySelectorAll('.dw-typed-text:not(.dw-typed-text--initialized)').forEach( el => {
        el.classList.add('dw-typed-text--initialized');

        let entries = [];
        let maxEntryWidth = 0;
        
        el.querySelectorAll('.dw-typed-text--entry').forEach( (entry, i) => {
          if (entry.offsetWidth > maxEntryWidth) {
            maxEntryWidth = entry.offsetWidth;
          }
          entries.push(entry.textContent);
        });

        el.innerHTML = "";
        el.style.minWidth = maxEntryWidth + 'px';

        let currentEntryIndex = 0;
        let currentTypedText = "";

        function startTyping(nextWordPlease) {
          if (nextWordPlease) {
            el.textContent = "";
            el.classList.remove('dw-typed-text--end-of-entry');
            currentEntryIndex++;
            if (currentEntryIndex >= entries.length) {
              currentEntryIndex = 0;
            }
          }

          const entry = entries[currentEntryIndex];
          if (el.textContent.length === entry.length) {
            // Done Typing, on to next entry
            setTimeout(startTyping, 1000, true );
            el.classList.add('dw-typed-text--end-of-entry');
          } else {
            // Typing
            el.textContent = entry.substring(0, el.textContent.length + 1);
            setTimeout(startTyping, 100, false);
          }
        }
        startTyping();
      });
    }

    function calculateIntersectionRatio(element) {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.bottom <= 0 || rect.top >= windowHeight) {
        // The element is entirely outside the viewport
        return 0;
      }

      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      const elementHeight = rect.height;

      return visibleHeight / elementHeight;
    }

    function throttle(func, delay) {
      let lastTimestamp = 0;
      let timeoutId;

      return function (...args) {
        const now = Date.now();

        if (now - lastTimestamp >= delay) {
          func.apply(this, args);
          lastTimestamp = now;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastTimestamp = now;
          }, delay - (now - lastTimestamp));
        }
      };
    }

    function initScrollBehaviorHelper() {
      // INTERSECTION OBSERVER WAY IS BUGGY FOR MOBILE
      // const callback = (entries, observer) => {
      //   entries.forEach((entry) => {
      //     if (entry.boundingClientRect.y > (-window.innerHeight)) {
      //       entry.target.classList.remove('end'); 
      //     } else { 
      //       entry.target.classList.add('end'); 
      //     }
      //     if (entry.intersectionRatio > 0) {
      //       entry.target.classList.add('active'); 
      //     } else {
      //       entry.target.classList.remove('active'); 
      //     }
      //   });
      // };
      // const options = {
      //   root: null,
      //   rootMargin: "0px",
      //   threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
      // }

      // observer = new IntersectionObserver(callback, options);
      // const section = document.querySelectorAll('.dw-fp-top-banner').forEach( el => {
      //   observer.observe(el);
      // });

      // SCROLL WAY IS BETTER FOR MOBILE
      function checkIntersectionTopBanner() {
        const sections = document.querySelectorAll('.dw-fp-top-banner');
        const windowHeight = window.innerHeight;
  
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          if (rect.top > -windowHeight) {
            section.classList.remove('end');
          } else {
            section.classList.add('end');
          }
  
          // Calculate the percentage of the section that is visible in the viewport
          const intersectionRatio = calculateIntersectionRatio(section);
          if (intersectionRatio > 0) {
            section.classList.add('active');
          } else {
            section.classList.remove('active');
          }
        });
      }

      const handleScroll = throttle(checkIntersectionTopBanner, 100);

      // Add a scroll event listener to trigger the behavior
      window.addEventListener('scroll', handleScroll);

      // Initial invocation to set the initial state
      handleScroll();
    }

    function initBlock1ContentAnimations() {
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0 && entry.boundingClientRect.y > (-window.innerHeight)) {
            const top_banner = entry.target.closest('.dw-fp-top-banner');
            const text = top_banner.querySelector('.dw-fp-top-banner--block-1-text');
            const title = top_banner.querySelector('.dw-fp-top-banner--block-1-title');

            let title_opacity = 1 - entry.intersectionRatio;
            if (title_opacity > .5) {
              title_opacity =  Math.min(1, 2 * title_opacity  * title_opacity);
            }
            let text_opacity = 1 - title_opacity;

            title.style.opacity = title_opacity;
            text.style.opacity = text_opacity;

            let easeInIntersectionRatio = Math.min(1, 2 * entry.intersectionRatio * entry.intersectionRatio); 
            const yOffset = 100 * easeInIntersectionRatio;
            title.style.transform = `translateY(${ yOffset }%)`;
          }
        });
      };
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
      }

      observer = new IntersectionObserver(callback, options);
      const section = document.querySelectorAll('.dw-fp-top-banner--block-2').forEach( el => {
        observer.observe(el);
      });
    }

    function initBlock3ContentAnimations() {
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0 && entry.boundingClientRect.y > (-window.innerHeight)) {
            const top_banner = entry.target.closest('.dw-fp-top-banner');
            const image1 = top_banner.querySelector('.dw-fp-top-banner--block-3-image-1');
            const image2 = top_banner.querySelector('.dw-fp-top-banner--block-3-image-2');

            let opacity = 1 - entry.intersectionRatio;
            if (opacity > .5) {
              opacity =  Math.min(1, 2 * opacity  * opacity);
            }

            image2.style.opacity = opacity;

            let easeInIntersectionRatio = Math.min(1, 2 * entry.intersectionRatio * entry.intersectionRatio); 
            const scale = 100 * ( 1 - easeInIntersectionRatio);
            const xOffset = 32.292 * (1 - easeInIntersectionRatio);
            image2.style.transform = `translateY(50%) scale(${ scale }%)`;
            image1.style.transform = `translateY(50%) translateX(${ xOffset }vw)`;
          }
        });
      };

      const options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0]
      }

      observer = new IntersectionObserver(callback, options);
      const section = document.querySelectorAll('.dw-fp-top-banner--block-2').forEach( el => {
        observer.observe(el);
      });
    }

    function initBlock3ContentAnimationsForMobile() {
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0 && entry.boundingClientRect.y > (-window.innerHeight)) {
            const top_banner = entry.target.closest('.dw-fp-top-banner');
            const image1 = top_banner.querySelector('.dw-fp-top-banner--block-3-image-1');
            const image2 = top_banner.querySelector('.dw-fp-top-banner--block-3-image-2');

            let opacity = 1 - entry.intersectionRatio;
            if (opacity > .5) {
              opacity =  Math.min(1, 2 * opacity  * opacity);
            }

            image2.style.opacity = opacity;

            let easeInIntersectionRatio = Math.min(1, 2 * entry.intersectionRatio * entry.intersectionRatio); 

            const yOffset = 29 * ( 1 - easeInIntersectionRatio);
            image1.style.transform = `translateY(-50%) rotate(90deg) translateX(${ yOffset }vh)`;

            const scale = 100 * ( 1 - easeInIntersectionRatio);
            const yOffset2 = (100 * (-78 / 692)) * (easeInIntersectionRatio );
            image2.style.transform = `translateX(-50%) rotate(90deg) translateX( ${ yOffset2 }vh) scale(${ scale }%)`;
          }
        });
      };

      const options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0]
      }

      observer = new IntersectionObserver(callback, options);
      document.querySelectorAll('.dw-fp-top-banner--block-2-bg').forEach( el => {
        observer.observe(el);
      });
    }

    function initMobileOnlyBlockSpaceAdjustments() {
      document.querySelectorAll('.dw-fp-top-banner--mobile-only-block').forEach( el => {
        const top_banner = el.closest('.dw-fp-top-banner');
        
        function adjustMargin() {
          if (window.innerWidth < 768) {
            top_banner.style['margin-bottom'] = el.clientHeight + 'px';
          } else {
            top_banner.style['margin-bottom'] = '0';
          }
        }

         window.addEventListener('resize', adjustMargin);
         adjustMargin();
      });
    }

    initScrollBehaviorHelper();
    initMobileOnlyBlockSpaceAdjustments();
    if (window.innerWidth >= 768) {
      // TODO: Run these for Desktop Only
      initBlock1ContentAnimations();
      initBlock3ContentAnimations();
    } else {
      initBlock3ContentAnimationsForMobile();
    }
    initTypedText();
  });
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drywater-technology-banner"] && !Shopify.designMode) return;
  try {
    
 
  const container = document.querySelector('.shopify-section--dw-tech-banner .dw-tech-banner');
  const floater = document.querySelector('.shopify-section--dw-tech-banner .dw-tech-banner--floating-media');
  const block1 = document.querySelector('.shopify-section--dw-tech-banner .dw-tech-banner > :first-child');
  const block2 = document.querySelector('.shopify-section--dw-tech-banner .dw-tech-banner > :nth-child(2)');
  const block3 = document.querySelector('.shopify-section--dw-tech-banner .dw-tech-banner > :nth-child(3)');

  const scrollHandlerForMobile = () => {
    const top = container.getBoundingClientRect().top;
    if (top > 1) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block2.style['margin-top'] = '';
      block3.classList.remove('dw-tech-banner--block-active');
      block3.style['margin-top'] = '';
    } else if (top > (- block1.clientHeight )) {
      block1.classList.add('dw-tech-banner--block-active');
      block2.style['margin-top'] = block1.clientHeight + 'px';
      block2.classList.remove('dw-tech-banner--block-active');
      block3.classList.remove('dw-tech-banner--block-active');
      block3.style['margin-top'] = '';
    } else if (top > (- block1.clientHeight - block2.clientHeight )) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.add('dw-tech-banner--block-active');
      block2.style['margin-top'] = '';
      block3.classList.remove('dw-tech-banner--block-active');
      block3.style['margin-top'] = block2.clientHeight + 'px';
    } else if (top > (- block1.clientHeight - block2.clientHeight - block3.clientHeight )) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block2.style['margin-top'] = '';
      block3.classList.add('dw-tech-banner--block-active');
      block3.style['margin-top'] = '';
    } else {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block2.style['margin-top'] = '';
      block3.classList.remove('dw-tech-banner--block-active');
      block3.style['margin-top'] = '';
    }
  };

  const scrollHandlerForDesktop = () => {
    const top = container.getBoundingClientRect().top;
    if (top > 0) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block3.classList.remove('dw-tech-banner--block-active');

      floater.classList.add('dw-tech-banner--floating-media-entering');
      floater.classList.remove('dw-tech-banner--floating-media-active');
      floater.classList.remove('dw-tech-banner--floating-media-exiting');
    } else if (top > (- block1.clientHeight )) {
      floater.classList.add('dw-tech-banner--floating-media-active');
      block1.classList.add('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block3.classList.remove('dw-tech-banner--block-active');

      floater.classList.remove('dw-tech-banner--floating-media-entering');
      floater.classList.add('dw-tech-banner--floating-media-active');
      floater.classList.remove('dw-tech-banner--floating-media-exiting');
    } else if (top > (- block1.clientHeight - block2.clientHeight )) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.add('dw-tech-banner--block-active');
      block3.classList.remove('dw-tech-banner--block-active');

      floater.classList.remove('dw-tech-banner--floating-media-entering');
      floater.classList.add('dw-tech-banner--floating-media-active');
      floater.classList.remove('dw-tech-banner--floating-media-exiting');
    } else if (top > (- block1.clientHeight - block2.clientHeight - block3.clientHeight )) {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block3.classList.add('dw-tech-banner--block-active');

      floater.classList.remove('dw-tech-banner--floating-media-entering');
      floater.classList.remove('dw-tech-banner--floating-media-active');
      floater.classList.add('dw-tech-banner--floating-media-exiting');
    } else {
      block1.classList.remove('dw-tech-banner--block-active');
      block2.classList.remove('dw-tech-banner--block-active');
      block3.classList.remove('dw-tech-banner--block-active');

      floater.classList.remove('dw-tech-banner--floating-media-entering');
      floater.classList.remove('dw-tech-banner--floating-media-active');
      floater.classList.add('dw-tech-banner--floating-media-exiting');
    }
  }

  const resizeHandler = () => {
    if (window.innerWidth >= 768) {
      document.removeEventListener("scroll", scrollHandlerForMobile, { passive: true });

      //cleanup margins
      block2.style['margin-top'] = '';
      block3.style['margin-top'] = '';

      scrollHandlerForDesktop();
      document.addEventListener("scroll", scrollHandlerForDesktop, { passive: true });
    } else {
      document.removeEventListener("scroll", scrollHandlerForDesktop, { passive: true });

      scrollHandlerForMobile();
      document.addEventListener("scroll", scrollHandlerForMobile, { passive: true });
    }
  };

  window.addEventListener('resize', resizeHandler);
  resizeHandler();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      console.log('--header-height', `${this.header.offsetHeight}px`)
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  /* -- START -- Change images with [data-dw-current-variant-img] to currently selected variant */

  const updateCurrentVariantImages = (interval) => {
    const variantImg = document.querySelector('.shopify-section--main-product .product--thumbnail_slider .product__media-item.is-active img');
    if (variantImg && variantImg.currentSrc) {
      document.querySelectorAll('[data-dw-current-variant-img]').forEach( img => {
        img.src = variantImg.currentSrc;
        img.dataset.dwCurrentVariantImg = 'loaded';
      });
      clearInterval(interval);
    }
  };
  updateCurrentVariantImages();
  document.querySelectorAll('variant-radios input[type=radio][name]').forEach( radio => {
    radio.addEventListener('change', e=> {
      /* Set all images to loading */
      document.querySelectorAll('[data-dw-current-variant-img]').forEach( img => {
        img.dataset.dwCurrentVariantImg = 'loading';
      });

      /* Update images when image is available */
      const itemImgPoller = setInterval( () => { updateCurrentVariantImages(itemImgPoller); }, 100);
    });
  });


  /* --END-- */


  const nextBtnClick = (e) => {
    
    const nextBtn = e.currentTarget;
    const thumbnailList = nextBtn.closest('slider-component').querySelector('.thumbnail-list');
    const current = thumbnailList.querySelector('.thumbnail-list__item button[aria-current]');

    let nextItem = current.closest('.thumbnail-list__item').nextElementSibling;
    /* Make sure nextitem is not hidden */
    while (nextItem && nextItem.offsetParent === null) {
      nextItem = nextItem.nextElementSibling;
    }

    if (nextItem) {
      nextItem.querySelector('button').dispatchEvent(new MouseEvent('click'));
    } else {
      thumbnailList.querySelector('.thumbnail-list__item:first-of-type button').dispatchEvent(new MouseEvent('click'));
    }
  };

  const prevBtnClick = (e) => {
    const prevBtn = e.currentTarget;
    const thumbnailList = prevBtn.closest('slider-component').querySelector('.thumbnail-list');
    const current = thumbnailList.querySelector('.thumbnail-list__item button[aria-current]');
  
    if (!current) {
      console.error('No currently active thumbnail found.');
      return;
    }
  
    const currentItem = current.closest('.thumbnail-list__item');
  
    // Check if the current item is the first item
    if (currentItem === thumbnailList.querySelector('.thumbnail-list__item:first-of-type')) {
      console.warn('Already on the first slide. Prev button disabled.');
      return;
    }
  
    let prevItem = currentItem.previousElementSibling;
  
    /* Make sure prevItem is not hidden */
    while (prevItem && prevItem.offsetParent === null) {
      prevItem = prevItem.previousElementSibling;
    }
  
    if (prevItem) {
      prevItem.querySelector('button').dispatchEvent(new MouseEvent('click'));
    } else {
      console.error('Unexpected error: No previous item found.');
    }
  
    // Ensure the slider updates properly after changing the active item
    const sliderComponent = prevBtn.closest('slider-component');
    if (sliderComponent && typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    } else {
      console.warn('Slider component does not have an update function.');
    }
  };

  document.querySelectorAll('.shopify-section--main-product slider-component.thumbnail-slider .drywater-next-button').forEach( nextBtn => {
    nextBtn.addEventListener('click', nextBtnClick);
  });

  document.querySelectorAll('.shopify-section--main-product slider-component.thumbnail-slider .drywater-prev-button').forEach( nextBtn => {
    nextBtn.addEventListener('click', prevBtnClick);
  });

  


  /* Product Link Variants */
  function handleChangeToLinkURLs(e) {
    const value = e.target.value;
    e.target.querySelectorAll('option[data-link-url]').forEach( option => {
      if (option.value == e.target.value) {

        document.documentElement.style.transition = 'opacity .25s';
        document.documentElement.style.opacity = 0;
        sessionStorage.setItem("dwScrollY", window.scrollY);

        document.location = option.dataset.linkUrl; 
      }
    });
  }
  document.querySelectorAll('.shopify-section--main-product select.select__select > option[data-link-url]').forEach(option => {
    const select = option.parentElement;
    if (!select.matches('.link-urls-initialized')) {
      select.classList.add('link-urls-initialized');
      select.addEventListener('change', handleChangeToLinkURLs);
    }
  });

  /* Recharge Custom Tweaks */
  document.querySelectorAll('.shopify-section--main-product .shopify-block.shopify-app-block.recharge-subscription-widget').forEach( rcBlock => {

  const isV2 = rcBlock.closest('.shopify-section--main-product .v2') ? true : false;

    function formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format;

      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    const widget = rcBlock.querySelector('[id^="RechargeWidget_"]');
    const section = widget.closest('.shopify-section--main-product');
    const config = { attributes: true, childList: true, subtree: true };
    const hasHadVariantChange = false;


    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) { 
        switch(mutation.type) {
          case "childList":
            if (mutation.removedNodes.length == 0)  {
              modifyOneTimePurchaseRadio();
              modifySubscribeAndSaveRadio();

              /* trigger once just to initialize values that depend on the product price changes like the subscribe and save price updates to product price */
              if (!hasHadVariantChange && widget.querySelector('.rc-radio.subscription-radio .rc-radio__label')) {
                section.querySelector('variant-selects')?.onVariantChange();
              }
            }
            if (mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach( node => {
                if (node.nodeType == Node.ELEMENT_NODE && node.matches('.rc-selling-plans')) {
                  modifySellingPlansSelector();
                }
              });
            } else if (widget.querySelector('.rc-selling-plans .rc-selling-plans-dropdown__select:not([data-dw-select="initialized"])')) {
              modifySellingPlansSelector();
            }
            break;

          case "attributes":
            if (mutation.target.matches('.rc-radio.rc-radio--active')) {
              const rechargeWidget = Recharge.widgets[widget.id.split('_')[1]];
              const variantId =  rechargeWidget.state.variant;
              const rechargeVariant= rechargeWidget.product.variants.find(variant => (variant.external_variant_id == variantId));
              let activePlanId = null; 
              if (mutation.target.matches('.onetime-radio')) {
                activePlanId = rechargeWidget.product.plans.find( plan => (plan.type == 'onetime'))?.id;
              } else if (mutation.target.matches('.subscription-radio')){
                activePlanId = rechargeWidget.product.plans.find( plan => (plan.type == 'subscription'))?.id;
              }
              const activePlan = rechargeVariant.prices[0].plans.find(plan => (plan.id == activePlanId));

              //Update button prices
              const priceEl = widget.closest('product-info').querySelector('.btn_price .price');
              if (parseFloat(activePlan.discount_value) == 0) {
                priceEl.classList.remove('price--on-sale');
                priceEl.querySelector('.price__regular .price-item--regular').textContent = '$' + activePlan.discounted_price;
              } else {
                priceEl.classList.add('price--on-sale');
                priceEl.querySelector('.price__sale .price-item--sale').textContent = '$' + activePlan.discounted_price;
              }

              recalculateSaveAmountsOnPackSize();
            } 
            break;
        }
      }
    };

    function recalculateSaveAmountsOnPackSize() {
      const rechargeActiveRadio = widget.querySelector('.rc-radio.rc-radio--active');
      const productInfo = widget.closest('product-info');
      const packSizeRadios = productInfo.querySelectorAll('[type=radio][name="Pack Size"]');


      // Get Base Variant Price
      const rechargeWidget = Recharge.widgets[widget.id.split('_')[1]];
      const variantId =  rechargeWidget.state.variant;
      const rechargeVariant= rechargeWidget.product.variants.find(variant => (variant.external_variant_id == variantId));

      const currentFlavor = rechargeVariant.option_values[0];
      const currentFlavorPackVariants = rechargeWidget.product.variants.filter(variant => variant.option_values[0] == currentFlavor);
      let currentFlavorBaseVariantPackSize = null; 
      const currentFlavorBaseVariantPrice = currentFlavorPackVariants.reduce((result, currentValue, currentIndex, arr) => { 
        let result_price = null;
        if (typeof(result) == 'object') { 
          result_price =  parseFloat(result.prices[0].unit_price); 
        } else {
          result_price = result;
        }
        const unit_price = parseFloat(currentValue.prices[0].unit_price); 
        if (result_price < unit_price ) { 
          if (typeof(result) == 'object') {
            currentFlavorBaseVariantPackSize = result.option_values[1];
          }
          return result_price; 
        } else { 
          currentFlavorBaseVariantPackSize = currentValue.option_values[1];
          return unit_price; 
        }
      });

      let activePlanId = null;
      if (rechargeActiveRadio.matches('.onetime-radio')) {
        activePlanId = rechargeWidget.product.plans.find(plan => plan.type=="onetime")?.id;
      } else if (rechargeActiveRadio.matches('.subscription-radio')) {
        activePlanId = rechargeWidget.product.plans.find(plan => plan.type=="subscription")?.id;
      }

      packSizeRadios.forEach( radio => {
        const packSize = radio.value;
        const label = radio.nextElementSibling;

        const currentPackVariant = currentFlavorPackVariants.find( variant => variant.option_values[1] == packSize );
        const currentPackVariantPrice = currentPackVariant.prices[0].plans.find( plan => plan.id == activePlanId )?.discounted_price;

        
        const savedPrice = ((currentFlavorBaseVariantPrice * ( parseInt(packSize) / parseInt(currentFlavorBaseVariantPackSize))) - currentPackVariantPrice);
        const savedMoney = formatMoney(Math.round(savedPrice) * 100, '${{amount_no_decimals}}');  
        
        let dwOptionSavedPrice = label.querySelector('.dw-option-saved-price'); 
          if (dwOptionSavedPrice) {
            if (savedPrice > 0) {
              dwOptionSavedPrice.textContent = 'Save ' + savedMoney;   
            } else {
              dwOptionSavedPrice.remove(); 
            }
          } else if ( savedPrice > 0) {
            label.insertAdjacentHTML('beforeend',`<span class="dw-option-saved-price">Save ${ savedMoney }</span>`);  
          }
      });
    }

    const observer = new MutationObserver(callback);
    observer.observe(widget, config);
    startUpdatingPriceWithSubscriptionPriceWhenNecessary();

    function modifyOneTimePurchaseRadio() {
      const oneTimeRadioLabel = widget.querySelector('.rc-radio.onetime-radio .rc-radio__label');
      if (oneTimeRadioLabel && oneTimeRadioLabel.childNodes[1].textContent.includes('$')) { 
        const select = widget.closest('product-info').querySelector('variant-selects [name="options[Pack Size]"]');
        const radio = widget.closest('product-info').querySelector('variant-radios [name="Pack Size"]:checked');
        let qty = 0;

        if (select || radio) {

          if (select) {
            qty = parseInt(select.value);
          } else if (radio) {
            qty = parseInt(radio.value);
          }

          const price = oneTimeRadioLabel.childNodes[1].textContent.split('$')[1];
          const price_per_stick = '$' + (Math.round(((price / qty) + Number.EPSILON) * 100) / 100).toFixed(2);
          oneTimeRadioLabel.childNodes[1].textContent = "One-time purchase";

          if (isV2) {
            const pricesSpan = oneTimeRadioLabel.querySelector('.dw-rc-radio__prices');
            if (pricesSpan) {
              pricesSpan.remove();
            }
            oneTimeRadioLabel.insertAdjacentHTML('beforeend',`<span class="dw-rc-radio__prices"><span class="dw-rc-radio__price-per-stick">${ price_per_stick } <span class="dw-rc-radio__price-per-stick-uom">/stick</span></span><span class="dw-rc-radio__price">$${ price }</span></span>`);  
          } else {
            const pricePerStickSpan = oneTimeRadioLabel.querySelector('.dw-rc-radio__price-per-stick');
            if (pricePerStickSpan) {
              pricePerStickSpan.remove();
            }
            oneTimeRadioLabel.insertAdjacentHTML('beforeend',`<span class="dw-rc-radio__price-per-stick">${ price_per_stick } <span class="dw-rc-radio__price-per-stick-uom">/stick</span></span>`);  
          }
        }
      }
    }
 
    function modifySubscribeAndSaveRadio() {
      const subscriptionRadioLabel = widget.querySelector('.rc-radio.subscription-radio .rc-radio__label');
      if (subscriptionRadioLabel === null) return;


      /* Initalize HTML */
      if (isV2) {
        const subscriptionRadioPromoV2 = subscriptionRadioLabel.querySelector('.dw-rc-radio__promo_v2');  
        if (!subscriptionRadioPromoV2) {
          subscriptionRadioLabel.insertAdjacentHTML('beforeend', `
          <div class="dw-rc-radio__promo_v2">
            <div class="dw-rc-radio__promo_item">
              <div class="dw-rc-radio__promo_item-image">
                <img data-dw-current-variant-img src="" width="160" height="160">
                </img>
              </div>
              <div class="dw-rc-radio__promo_item-title" data-pack-size></div>
              <div class="dw-rc-radio__promo_item-price"><span data-stick-price></span></div>
            </div>
            <div class="dw-rc-radio__promo_item">
              <div class="dw-rc-radio__promo_item-image">
                <img src="${ window.drywaterRcPromo.v2.free_image_url }" width="160" height="160">
              </div>
              <div class="dw-rc-radio__promo_item-title free">${ window.drywaterRcPromo.v2.free_title }</div>
            </div>
          </div>`);
          updateCurrentVariantImages();
        }
      } else {
        const subscriptionRadioPromo = subscriptionRadioLabel.querySelector('.dw-rc-radio__promo');  
        if (!subscriptionRadioPromo) {
          subscriptionRadioLabel.insertAdjacentHTML('beforeend',` 
            <span class="dw-rc-radio__promo">
              <span class="dw-rc-radio__promo-offer-text">${ window.drywaterRcPromo.title }</span>
              <span class="dw-rc-radio__promo-tooltip-icon"></span>
              <span class="dw-rc-radio__promo-tooltip">
                <span class="dw-rc-radio__promo-tooltip-title">${ window.drywaterRcPromo.tooltip.title }</span>
                <span class="dw-rc-radio__promo-tooltip-text-left">${ window.drywaterRcPromo.tooltip.text1 }</span>
                <span class="dw-rc-radio__promo-tooltip-text-left">${ window.drywaterRcPromo.tooltip.text2 }</span>
              </span>
            </span>`);  
        }
      } 

      /* Show/Hide Promo where appropriate */
      const packInput = section.querySelector('[data-option-name="Pack Size"] input:checked');  
      if (isV2) { 
        const hasPromo = packInput.nextElementSibling.querySelector('.pack-size-desc:not(:empty)');
        if (!hasPromo) {
          subscriptionRadioLabel.closest('label').classList.remove('rc-radio--has-promo');
        } else {
          subscriptionRadioLabel.closest('label').classList.add('rc-radio--has-promo');
        }
      }

      const subscriptionRadioPrice = subscriptionRadioLabel.querySelector('.rc-radio__price');  
      if (subscriptionRadioPrice && subscriptionRadioPrice.textContent !== "") {



        /* Update HTML */
        const select = widget.closest('product-info').querySelector('variant-selects [name="options[Pack Size]"]')
        const radio = widget.closest('product-info').querySelector('variant-radios [name="Pack Size"]:checked');
        let qty = 0;

        if (select || radio) {

          if (select) {
            qty = parseInt(select.value);
          } else if (radio) {
            qty = parseInt(radio.value);
          }

          const one_time_price = widget.querySelector('.rc-radio.onetime-radio .dw-rc-radio__price')?.textContent;

          const price = subscriptionRadioPrice.textContent.split('$')[1];
          const price_per_stick = '$' + (Math.round(((price / qty) + Number.EPSILON) * 100) / 100).toFixed(2);

          subscriptionRadioLabel.querySelector('.rc-radio__subscription').textContent = 'Subscribe & Save';
          subscriptionRadioPrice.dataset.originalValue = subscriptionRadioPrice.textContent;
          subscriptionRadioPrice.textContent = "";

          if (isV2) { 
            const pricesSpan = subscriptionRadioLabel.querySelector('.dw-rc-radio__prices');
            if (pricesSpan) {
              pricesSpan.remove();
            }
            subscriptionRadioLabel.insertAdjacentHTML('beforeend',`<span class="dw-rc-radio__prices"><span class="dw-rc-radio__one-time-price">${ one_time_price }</span><span class="dw-rc-radio__price">$${ price }</span></span>`);  

            const packSizeDiv = subscriptionRadioLabel.querySelector('[data-pack-size]');
            const packSize = packInput.value;
            if (packSizeDiv) {
              packSizeDiv.textContent = packSize;
            }

            const stickPriceSpan = subscriptionRadioLabel.querySelector('[data-stick-price]');
            if (stickPriceSpan) {
              stickPriceSpan.textContent = price_per_stick;
            }


          } else {
            const pricePerStickSpan = subscriptionRadioLabel.querySelector('.dw-rc-radio__price-per-stick');
            if (pricePerStickSpan) {
              pricePerStickSpan.remove();
            }
            subscriptionRadioLabel.insertAdjacentHTML('beforeend',`<span class="dw-rc-radio__price-per-stick">${ price_per_stick } <span class="dw-rc-radio__price-per-stick-uom">/stick</span></span>`);  
          }
        } 
      }

    }

    function modifySellingPlansSelector() {
      const select = widget.querySelector(".rc-selling-plans-dropdown__select:not([data-dw-select='initialized'])");
      select.dataset.dwSelect = "initialized";

      const createFakeSelect = (select, openDirection = 'down') => {
        let html = `<div class="dw-select dw-select-${ openDirection }"><button class="dw-select--button" data-dw-select-value="${ select.value }">${ select.options[select.selectedIndex].text }</button><ul class="dw-select--values">`;
        select.querySelectorAll('option').forEach( option => {
          html += `<li class="dw-select--value" data-dw-select-value="${ option.value }" ${ option.selected ? 'data-dw-select-selected="true"' : '' }>${ option.text }</li>`
        });
        html += `</ul></div>`;
        select.insertAdjacentHTML("afterend", html);
        select.style.display = "none";

        return select.nextElementSibling;
      };

      const attachFakeSelect = (fakeSelect, select) => {
        const button = fakeSelect.querySelector('.dw-select--button');
        button.addEventListener('click', e => {
          if (fakeSelect.dataset.dwSelectOpen) {
            delete(fakeSelect.dataset.dwSelectOpen);
          } else {
            document.querySelectorAll('.dw-select').forEach( dwSelect => { delete(dwSelect.dataset.dwSelectOpen); } );
            fakeSelect.dataset.dwSelectOpen = true;
          }
        });

        fakeSelect.querySelectorAll('li').forEach( li => {
          li.addEventListener('click', e => {
            delete(fakeSelect.dataset.dwSelectOpen);
            button.textContent = li.textContent;
            button.dataset.dwSelectValue = li.dataset.dwSelectValue;
            select.value = li.dataset.dwSelectValue;
            select.dispatchEvent(new Event('change'));
            select.closest('variant-selects').dispatchEvent(new Event('change'));
          });
        });
      };

      fakeSelect = createFakeSelect(select, 'up');
      attachFakeSelect(fakeSelect, select);

      /* 2024-01-26 - Hide Fake Selling Plan Selector as well, client wants them to select later in the mini cart. */
      fakeSelect.style.display = "none";
    }
    
    function startUpdatingPriceWithSubscriptionPriceWhenNecessary() {
      const srcButton = section.querySelector('.product-form__submit');
      const price = srcButton.querySelector('.btn_price');

      const forceVariantChangeEvents = () => {
        section.querySelector('variant-selects')?.onVariantChange();
      };
 
      const updatePriceWithSubscriptionPrice = () => { 
        const subscriptionRadio = widget.querySelector('.rc-radio.subscription-radio .rc-radio__input');
        if (subscriptionRadio.checked) {
          const subscriptionRadioPrice = widget.querySelector('.rc-radio.subscription-radio .rc-radio__label .rc-radio__price');  
          const subscriptionPrice = subscriptionRadioPrice.dataset.originalValue;

          let priceToUpdate;
          if (price.querySelector('.price.price--on-sale')) {
            priceToUpdate = price.querySelector('.price-item--sale');
          } else {
            priceToUpdate = price.querySelector('.price-item.price-item--regular'); 
          }
          if (subscriptionPrice && priceToUpdate.textContent !== subscriptionPrice) {
            priceToUpdate.textContent = subscriptionPrice; 
            const subscriptionRadio = widget.querySelector('.rc-radio.subscription-radio .rc-radio__input');
            const oneTimeRadio = widget.querySelector('.rc-radio.onetime-radio .rc-radio__input');
            subscriptionRadio.addEventListener('change', forceVariantChangeEvents);
            oneTimeRadio.addEventListener('change', forceVariantChangeEvents);
          } 
        } 

      }

      /* Unrelated to subscription but let's just do it here for simplicity's sake */
      const updateSavedPrice = () => {
        if (price.querySelector('.price.price--on-sale')) {
          const sale = price.querySelector('.price__sale');
          const priceSale = sale.querySelector('.price-item.price-item--sale').textContent.split('$')[1];
          const priceRegular = sale.querySelector('.price-item.price-item--regular').textContent.split('$')[1];
          const priceSaved = `$${(Math.round((( priceRegular - priceSale ) + Number.EPSILON) * 100) / 100).toFixed(2)}`;
          const priceToUpdate = price.querySelector('.dw--price-saved');
          if (priceToUpdate.textContent !== priceSaved ) {
            priceToUpdate.textContent = priceSaved;
          }
        }
      };

      const priceObserverCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            updatePriceWithSubscriptionPrice();
            updateSavedPrice();
          }
        }
      };

      const priceObserver = new MutationObserver(priceObserverCallback);
      priceObserver.observe(price, { attributes: false, childList: true, subtree: true });

      /* Wait for Recharge before updating subscription price */
      const waitingForRecharge = setInterval(function() {
        const subscriptionRadio = widget.querySelector('.rc-radio.subscription-radio .rc-radio__input');
        if (subscriptionRadio) {
          clearInterval(waitingForRecharge);
          updatePriceWithSubscriptionPrice();
          recalculateSaveAmountsOnPackSize();
        }
      }, 1000);

    }

  });

  /* Toggle Show/Hide Based on selected variant option radio */
  (() => {
    const handleize = (str) => {
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
        .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
        .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
        .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
        .toLowerCase(); // To lowercase

      return str
    };

    document.querySelectorAll('variant-radios[data-show-hide] input[type=radio][name]').forEach( radio => {
      radio.addEventListener('change', e=> {
        const name = handleize(radio.name);
        const value = handleize(radio.value);

        /* Update linked dwSelects */
        document.querySelectorAll(`select[data-dw-select][name="options[${ radio.name }]"]`).forEach( dwSelect => { 
          dwSelect.value = radio.value; 
          dwSelect.dispatchEvent(new Event('change'));
        });

        /* Elements */
        const hideThese = document.querySelectorAll('[class*=show-on--variant-option--' + name + '--]:not([class~=show-on--variant-option--' + name + '--' + value + '])'); 
        const showThese = document.querySelectorAll('[class~=show-on--variant-option--' + name + '--' + value + ']'); 

        hideThese.forEach(el => {
          el.style.display = "none";
          if (el.matches('.show-on--start-with-parent-section')) {
            el.closest('.shopify-section').style.display = "none";
          }
        });
        showThese.forEach(el => {
          el.style.display = "";
          if (el.matches('.show-on--start-with-parent-section')) {
            el.closest('.shopify-section').style.display = "";
          }
        });

      });

      /* Fire trigger to initialize */
      if (radio.checked) {
        radio.dispatchEvent(new Event('change'));
      }
    });
  })();



  /* Floating Add To Cart Bar */
  (() => {
    const section = document.querySelector('.shopify-section--main-product');
    if (section && section.querySelector('.dw-floating-add-to-cart')) {
      initializeFloatingAddToCart();
    } 

    function initializeFloatingAddToCart() {
      /* Update/Init Flavor */
      const flavor = section.querySelector('.dw-floating-add-to-cart--flavor');
      const flavorSelect = section.querySelector('variant-selects select[name="options[Flavor]"]'); 
      const flavorRadios = section.querySelectorAll('variant-radios input[name="Flavor"]'); 

      if (flavorSelect) {
        const updateFlavor = () => {
          flavor.textContent = flavorSelect.querySelector('option[value="'+flavorSelect.value+'"]').textContent;
          flavor.dataset.value = flavorSelect.value;

          // Might as well update other elements on the page that need to be updated
          document.querySelectorAll('[data-dw-flavor]').forEach( el => {
            el.textContent = flavor.textContent;
            el.dataset.dwFlavor = flavorSelect.value;
          });
          document.body.dataset.dwBodyFlavor = flavorSelect.value;

        };
        flavorSelect.addEventListener('change', updateFlavor);
        updateFlavor();
      } else if (flavorRadios) {
        const updateFlavor = (e) => {
          const flavorRadio = [...flavorRadios].find(el => el.matches(':checked'));
          if ( flavorRadio ) {
            flavor.textContent = flavorRadio.value;
            flavor.dataset.value = flavorRadio.value;

            // Might as well update other elements on the page that need to be updated
            document.querySelectorAll('[data-dw-flavor]').forEach( el => { 
              el.textContent = flavor.textContent;
              el.dataset.dwFlavor = flavorRadio.value;
            });

            document.body.dataset.dwBodyFlavor = flavorRadio.value;
          }

        };
        flavorRadios.forEach(el => {
          el.addEventListener('change', updateFlavor);
        });
        updateFlavor();
      }



      /* Add/Init Variant Options */
      if (flavorSelect) {
        section.querySelectorAll('.dw-floating-add-to-cart select[name^="options["]').forEach( select => {
          const srcSelect = section.querySelector('variant-selects select[name="' + select.name + '"]');
          srcSelect.addEventListener('change', e => {
            if (select.value !== srcSelect.value) {
              select.value = srcSelect.value;
              select.dispatchEvent(new Event('change'));
            }
          });
          select.addEventListener('change', e => {
            if (select.value !== srcSelect.value) {
              srcSelect.value = select.value;
              srcSelect.dispatchEvent(new Event('change'));
              srcSelect.closest('variant-selects').dispatchEvent(new Event('change'));
            }
          });
        });
      } else if (flavorRadios) {
        section.querySelectorAll('.dw-floating-add-to-cart select[name^="options["]').forEach( select => {
          const radioName = select.name.match(/\[(.*)\]/)[1];
          const srcRadios = section.querySelectorAll('variant-radios input[name="' + radioName + '"]');
          srcRadios.forEach( srcRadio => {
            srcRadio.addEventListener('change', e => {
              if (srcRadio.matches(':checked')) {
                if (select.value !== srcRadio.value) {
                  select.value = srcRadio.value;
                  select.dispatchEvent(new Event('change'));
                }
              }
            });
          });

          select.addEventListener('change', e => {
            srcRadios.forEach( srcRadio => {
              if (select.value !== srcRadio.value) return;
              if (!srcRadio.checked) {
                srcRadio.checked = true;
                srcRadio.dispatchEvent(new Event('change'));
                srcRadio.closest('variant-radios').dispatchEvent(new Event('change'));
              }
            });
          });
        });
      }

      /* Trigger the real add to cart button when add to cart is pressed */
      const button = section.querySelector('.dw-floating-add-to-cart--button');
      const srcButton = section.querySelector('.product-form__submit');
      button.addEventListener('click', e => {
        srcButton.dispatchEvent(new MouseEvent('click'));  
      });
 
      /* Update Price on Price Changes */
      const price = srcButton.querySelector('.btn_price');
      const updatePrice = () => { 
        let priceText;
        /* const saleIsVisible = (price.querySelector('.price__sale').style.display == 'block');*/
        const saleIsVisible = price.querySelector('.price--on-sale');

        if (saleIsVisible) {
          priceText = price.querySelector('.price__sale .price-item--sale').textContent;
        } else {
          priceText = price.querySelector('.price__regular .price-item--regular').textContent;
        }

        button.querySelector('.dw-floating-add-to-cart--button-price').textContent = priceText; 
      };
      const priceObserverCallback = (mutationList, observer) => {
        updatePrice();
      };
      const priceObserver = new MutationObserver(priceObserverCallback);

      priceObserver.observe(price, { attributes: true, childList: true, subtree: true });
      updatePrice();

      /* Show when main product section is not visible */
      const handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            section.querySelector('.dw-floating-add-to-cart').classList.remove('dw-floating-add-to-cart--visible'); 
          } else {
            section.querySelector('.dw-floating-add-to-cart').classList.add('dw-floating-add-to-cart--visible'); 
          }
        });
      };
      const intersectionObserver = new IntersectionObserver( handleIntersect, {
          root: null,
          rootMargin: "0px",
          threshold: [0,0.001,0.01,0.1,1],
        });
      intersectionObserver.observe(section);

    }
  })();

  /* PLAY/PAUSE toggle on Product Media Gallery - Version2 */
  (()=>{ 
    const sliderGallery = document.querySelector('.section.shopify-section--main-product [id^="GalleryViewer-"] [id^="Slider-Gallery-"]');
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('video');
        const play_button = entry.target.querySelector('deferred-media button.deferred-media__poster');
        if (video || play_button) { 
          if (entry.intersectionRatio >= 0.5) {
            if (video) {
              video.play();
            } else {
              entry.target.querySelector('deferred-media button.deferred-media__poster').dispatchEvent(new MouseEvent('click'));
            }
          } else {
            video.pause();  
          }
        } 
      });
    };

    const observer = new IntersectionObserver(callback, {
      root: sliderGallery,
      rootMargin: "0px",
      threshold: [0.5]
    });

    // Observe all video slides
    sliderGallery.querySelectorAll("li deferred-media").forEach( deferredMedia => {
      observer.observe(deferredMedia.closest('li'));
    });
  })(); 



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shopify-section--product-benefits-section').forEach( section => {
    const topImage = section.querySelector('.product-benefits-section--top-image');
    const middleImage = section.querySelector('.product-benefits-section--middle-image');
    const bottomImage = section.querySelector('.product-benefits-section--bottom-image');

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: buildThresholdList(20)};

    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(section);

    function handleIntersect( entries ) {
      entries.forEach( entry => {

        if (entry.boundingClientRect.top > 0) {
          if (entry.intersectionRatio >= .6) {
            const offset = 110 * ((entry.intersectionRatio - .6)/.4);
            topImage.style.transform = 'translateY(-'+ offset +'px)';
            middleImage.style.transform = 'translateY(40%) scale('+ offset / 110 +')';
            /* middleImage.style.opacity = entry.intersectionRatio; */
            bottomImage.style.transform = 'translateY('+ offset +'px)';
          }
        } else {
          topImage.style.transform = 'translateY(-' + 110 + 'px)';
          middleImage.style.transform = 'translateY(40%) scale('+ 1 +')';
          /* middleImage.style.opacity = 1; */
          bottomImage.style.transform = 'translateY(' + 110 + 'px)';
        }
      }); 
    }

    function buildThresholdList(numSteps) {
      let thresholds = [];

      for (let i = 1.0; i <= numSteps; i++) {
        let ratio = i / numSteps;
        if (ratio >= .6) {
          thresholds.push(ratio);
        }
      }

      thresholds.push(0);
      return thresholds;
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-text"] && !Shopify.designMode) return;
  try {
    
  const productSection = document.querySelector('.shopify-section--main-product');
  const section = document.querySelector('.shopify-section--product-image-text');

  section.querySelectorAll('select[name^="options["]').forEach( select => {
    const srcSelect = productSection.querySelector('variant-selects select[name="' + select.name + '"]');
    if (srcSelect) {
      srcSelect.addEventListener('change', e => {
        if (select.value !== srcSelect.value) {
          select.value = srcSelect.value;
          select.dispatchEvent(new Event('change'));
        }
      });
      select.addEventListener('change', e => {
        if (select.value !== srcSelect.value) {
          srcSelect.value = select.value;
          srcSelect.dispatchEvent(new Event('change'));
          srcSelect.closest('variant-selects').dispatchEvent(new Event('change'));
        }
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-symptoms-section"] && !Shopify.designMode) return;
  try {
    
(()=>{
  /* 62% to 100% */
  document.querySelectorAll('.shopify-section--product-symptoms-section .over_text_isocell:not(.script-is-active)').forEach( target => {
    target.classList.add('script-is-active');
    target.style['padding-bottom']='50vh';
    target.style['pointer-events']='none';

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: buildThresholdList(100 - 62),
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(target);

    function handleIntersect( entries, observer ) {
      entries.forEach( entry => {
        if (entry.boundingClientRect.top > 0) {
          entry.target.textContent = (62 + Math.floor(entry.intersectionRatio * (100 - 62))) + '%';
        } else {
          entry.target.textContent = '100%';
        }
      });
    }

    function buildThresholdList(numSteps) {
      let thresholds = [];

      for (let i = 1.0; i <= numSteps; i++) {
        let ratio = i / numSteps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    }

  });
})();

  } catch(e) { console.error(e); }
})();
})();
